import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/TrueLinkRadios';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/TrueLinkTextInput';
import ErrorText from 'react/signups/card/common/ErrorText';
import trustDetailsShape from 'react/signups/card/shapes/TrustDetails';

export default function TrustDetailsForm({ onChange, values }) {
  const options = [
    {
      label: 'Yes',
      value: 'yes',
    },
    {
      label: 'No',
      value: 'no',
    },
  ];

  return (
    <>
      <CardText>Are you the trustee?</CardText>
      <TrueLinkRadios
        ariaLabel={'Are you the trustee? '}
        name="isTrustee"
        onChange={onChange}
        options={options}
        required
        value={values.isTrustee}
      />
      <ErrorText name="isTrustee" />

      {values.isTrustee === 'yes' && (
        <TrueLinkTextInput
          labelText="What is the name of the trust? "
          name="trustName"
          onChange={onChange}
          placeholder="Trust name"
          required
          value={values.trustName}
        />
      )}
    </>
  );
}

TrustDetailsForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: trustDetailsShape.isRequired,
};
